import ReportService from '@shopworx/services/api/report.service';

export default ({
  namespaced: true,
  actions: {
    executeReport: async (_, { reportName, payload }) => {
      try {
        const { data } = await ReportService.executeReport(reportName, payload);
        if (data && data.reportData) {
          return data.reportData;
        }
      } catch (e) {
        return false;
      }
      return false;
    },
    executeReportFile: async (_, { payload }) => {
      try {
        const { data } = await ReportService.executeReportFile(payload);
        if (data && data.returnCode === 200) {
          return data.msg;
        }
      } catch (e) {
        return false;
      }
      return false;
    },
    deleteReportFile: async (_, { query }) => {
      try {
        const { data } = await ReportService.deleteReportFile(query);
        if (data && data.returnCode === 200) {
          return data.msg;
        }
      } catch (e) {
        return false;
      }
      return false;
    },
  },
});
